import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("aw_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("aw_cart", JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => {
    setItems((cur) => {
      const found = cur.find((i) => i.slug === p.slug);
      if (found) return cur.map((i) => i.slug === p.slug ? { ...i, qty: Math.min(20, i.qty + qty) } : i);
      return [...cur, { slug: p.slug, title: p.title, price: p.price, image: p.image, qty }];
    });
    setOpen(true);
  };
  const setQty = (slug, qty) => setItems((cur) => qty <= 0 ? cur.filter((i) => i.slug !== slug) : cur.map((i) => i.slug === slug ? { ...i, qty } : i));
  const remove = (slug) => setItems((cur) => cur.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
